module.exports = __webpack_public_path__ + "static/about-img-9363e6977d8c23cfd72424a2485fb351.jpg";